import { Link } from "react-router-dom";
import { ACCOUNTS_BASE_URL } from "../lib/api";

export default function Landing() {
  return (
    <div style={{ display: "grid", placeItems: "center", minHeight: "100vh", padding: 24 }}>
      <div className="card stack" style={{ maxWidth: 520, width: "100%", padding: 32 }}>
        <h1 style={{ margin: 0, fontSize: 28 }}>Protopal</h1>
        <p className="muted" style={{ margin: 0 }}>
          The owner dashboard for your Prototypical site. Sign in to preview, publish, and manage integrations.
        </p>
        <div className="row">
          <a className="btn primary" href={`${ACCOUNTS_BASE_URL}/?next=${encodeURIComponent(`${window.location.origin}/dashboard`)}`}>
            Sign in
          </a>
          <Link className="btn" to="/dashboard">Continue</Link>
        </div>
      </div>
    </div>
  );
}
